import refund from "@components/refund/refund.vue";
import m2Sidebar from "@components/sidebar/m2_sidebar";
import editExamineeBaseInfo from "@components/editExamineeBaseInfo/editExamineeBaseInfo.vue";
export default {
  components: {
    refund: refund,
    m2Sidebar,
    editExamineeBaseInfo
  },
  data() {
    return {
      loading: false,
      showPrice: false,
      domain: this.$store.state.examInfo.currentExamInfo.domain,
      batchDataList: [],
      auditStatus: {},
      payState: {
        succeed: 2
      },
      regId: "",
      refundState: false,
      editBaseInfoDialogVisible: false,
      ruleForm: {
        field: []
      },
    };
  },
  methods: {
    handleClose() {
      this.editBaseInfoDialogVisible = false;
      this.ruleForm.field = [];
    },
    getData: function () {
      this.$http.get(globalProvider.serviceUrl("e_reg/g/erb"), {
        params: {
          loading: true
        }
      }).then(data => {
        if (data.body.code === resultCode.Success) {
          this.batchDataList = [];
          for (let i in data.body.data) {
            if (data.body.data[i].list.length > 0) {
              this.batchDataList.push(data.body.data[i]);
            }
          }
        } else if (data.body.code == resultCode.NotSuccess) {
          this.$alert(getErrorMessage(data.body.message));
        }
      });
    },
    //获取提交的报考信息
    getRegData(reg_id) {
      this.loading = true;
      this.$http
        .get(
          globalProvider.serviceUrl(
            "e_reg/g/eri/{reg_id}/{reg_info_operation}"
          ), {
          params: {
            reg_id: reg_id,
            reg_info_operation: 2
          }
        }
        )
        .then(data => {
          this.loading = false;
          if (data.body.code === resultCode.Success) {
            data.body.data.text_info_confs.forEach(item => {
              if (item._item_type == "name" && !item.py_value) {
                this.getPinYIn(item);
              }
              if (item.type == 8) {
                item.value = item.value == "" ? [] : item.value;
              }
              if (item.type == 7) {
                if (typeof item.value == "string") {
                  let list = [];
                  item.value.split("/").forEach((n, index) => {
                    list.push(
                      item.value
                        .split("/")
                        .slice(0, index + 1)
                        .join("/")
                    );
                  });

                  item.value = list;
                }
              }
            });
            this.ruleForm.field = data.body.data.text_info_confs;
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    getPinYIn: function (item) {
      if (item.sub_confs.enable_pinyin) {
        var n = pinyinUtil.getPinyin(item.value).toUpperCase();
        var j,
          num = 0;
        if (n) {
          for (let i of n.split(" ")) {
            if (n.indexOf(i) == 0 && num == 0) {
              num++;
              j = i + " ";
            } else {
              j = j + i;
            }
          }
        }
        item.py_value = j;
      }
    },
    editBaseInfo(item, i) {
      this.regId = item;
      this.editBaseInfoDialogVisible = true;
      this.getRegData(item);
    },
    handleBaseInfoSubmit(data) {
      this.editBaseInfoDialogVisible = false;
      this.$http
        .post(globalProvider.serviceUrl("e_reg/u/cerbi"), {
          exam_reg_id: this.regId,
          settings: data,
          pic_settings: "",
          exam_id: ""
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.$alert("保存成功");
          } else if (data.body.code == resultCode.NotSuccess) {
            if (data.body.message == "E_REG_LIMIT_RULES") {
              this.$alert(
                data.body.data,
                "提示", {
                confirmButtonText: "确定"
              }
              );
            } else {
              this.$alert(
                getErrorMessage(data.body.message),
                "提示", {
                confirmButtonText: "确定"
              }
              );
            }
          }
        });
    },
    refund(item) {
      this.$confirm(
        // "<div>1、考生在考试报名期间可随时申请或取消报名费用退款。报名截止后，系统不再受理任何退款或取消退款申请。</div><div>2、本次考试考生最终报考科目以报名时间截止时的科目缴费状态为准。考生将无法参加未缴费或已申请退款的科目考试。</div><div>3、报名费退款实行原缴费路径退回方式，申请退款的考生请务必确保原缴费银行卡或账户处于正常状态，否则将由考生自行承担退款失败无法到账产生相关责任风险。</div><div>4、退款产生的相关手续费用，由考生自行承担。</div><div></div>5、本次考试的退款操作将在报名结束后统一安排，请关注后续平台信息发布。</div>",
        "<div>是否确认申请退款？</div>",
        "退款申请", {
        confirmButtonText: "继续申请",
        dangerouslyUseHTMLString: true,
        customClass: "message",
        cancelButtonText: "取消"
      }
      )
        .then(() => {
          this.regId = item.reg_id;
          this.refundState = true;
        })
        .catch(() => {
          return false;
        });
    },
    cancelRefund(item) {
      this.$confirm(
        "请确认是否取消退费申请，确认取消后我们将不再为您执行退款操作",
        "取消申请", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }
      )
        .then(() => {
          this.$http
            .post(globalProvider.serviceUrl("e_reg/u/roi"), {
              reg_id: item.reg_id
            })
            .then(data => {
              if (data.body.code === resultCode.Success) {
                this.$alert("取消退款申请成功");
                this.getData();
              } else if (data.body.code == resultCode.NotSuccess) {
                this.$alert(getErrorMessage(data.body.message));
              }
            });
        })
        .catch(() => {
          return false;
        });
    },
    modifyInfo: function (reg_id) {
      let reg_info_operation = 1;
      this.$confirm(
        "考生修改信息后，请务必在【确认信息】页面提交报考信息",
        "注意", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }
      )
        .then(() => {
          this.$http
            .get(
              globalProvider.serviceUrl(
                "e_reg/g/eri/{reg_id}/{reg_info_operation}"
              ), {
              params: {
                reg_id: reg_id,
                reg_info_operation: reg_info_operation
              }
            }
            )
            .then(data => {
              if (data.body.code === resultCode.Success) {
                this.$store.commit("setExamRegInfo", data.body.data);
                this.getPromise();
              } else if (data.body.code == resultCode.NotSuccess) {
                this.$alert(getErrorMessage(data.body.message));
              }
            });
        })
        .catch(() => {
          return false;
        });
    },
    onRefund(val) {
      this.refundState = val;
      if (!val) {
        setTimeout(this.getData, 500);
      }
    },
    setBatch() {
      this.$http
        .get(globalProvider.serviceUrl("e_reg/g/bpe/{batch_id}"), {
          params: {
            batch_id: this.batch_id
          }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.createRegId();
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    getPromise: function () {
      this.$http.get(globalProvider.serviceUrl("e_reg/g/elc")).then(data => {
        if (data.body.code == resultCode.Success) {
          this.$store.commit("setPromiseState", data.body.data.status);
          this.$router.push({
            name: "default.examReg.baseCollection"
          });
        } else if (data.body.code == resultCode.NotSuccess) {
          this.$alert(getErrorMessage(data.body.message), "提示", {
            confirmButtonText: "确定"
          });
        }
      });
    },
    toPay(reg_id) {
      let reg_info_operation = 2;
      this.$http
        .get(
          globalProvider.serviceUrl(
            "e_reg/g/eri/{reg_id}/{reg_info_operation}"
          ), {
          params: {
            reg_id: reg_id,
            reg_info_operation: reg_info_operation
          }
        }
        )
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.$store.commit("setExamRegInfo", data.body.data);
            this.$router.push({
              name: "default.examReg.payOrder"
            });
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    addsubject(reg_id) {
      let reg_info_operation = 2;
      this.$http
        .get(
          globalProvider.serviceUrl(
            "e_reg/g/eri/{reg_id}/{reg_info_operation}"
          ), {
          params: {
            reg_id: reg_id,
            reg_info_operation: reg_info_operation
          }
        }
        )
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.$store.commit("setExamRegInfo", data.body.data);
            this.$router.push({
              name: "default.examReg.editSubject"
            });
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    editRegion(reg_id) {
      let reg_info_operation = 2;
      this.$http
        .get(
          globalProvider.serviceUrl(
            "e_reg/g/eri/{reg_id}/{reg_info_operation}"
          ), {
          params: {
            reg_id: reg_id,
            reg_info_operation: reg_info_operation
          }
        }
        )
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.$store.commit("setExamRegInfo", data.body.data);
            this.$router.push({
              name: "default.examReg.editRegion"
            });
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    toRegInfo(reg_id) {
      let reg_info_operation = 2;
      this.$http
        .get(
          globalProvider.serviceUrl(
            "e_reg/g/eri/{reg_id}/{reg_info_operation}"
          ), {
          params: {
            reg_id: reg_id,
            reg_info_operation: reg_info_operation
          }
        }
        )
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.$store.commit("setExamRegInfo", data.body.data);
            this.$router.push({
              name: "default.examReg.confirmRegInfo"
            });
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    objectSpanMethod({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (
        columnIndex === 0 ||
        columnIndex === 5 ||
        columnIndex === 8 ||
        columnIndex === 7 ||
        columnIndex === 6 ||
        columnIndex === 4
      ) {
        if (rowIndex == 0)
          return {
            rowspan: 100,
            colspan: 1
          };
        else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    isShowPrice() {
      this.showPrice = globalProvider.isGuideDomain(this.domain);
    }
  },
  created: function () {
    this.getData();
    this.auditStatus = auditStatus;
    this.$store.commit("setHeaderState", "0");
    this.isShowPrice();
  }
};